export const en = {
    'continue-edit': 'Continue editing',
    'default-name': 'New group',
    ok: 'OK',
    'previews-title': 'Preview creatives',
    'reset-smart-center': 'Set smart-center',
    'show-all-previews': 'Show all'
};
